import { Heading, Wrapper } from "./styles";
import { useState, useEffect, useCallback } from "react";

import api from "../../../../services/api";
import LoadingEditor from "../LoadingEditor";
import { useMainHook } from "../../../../hooks/main";

import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { Card } from "./components/card";
import { LeftArrow, RightArrow } from "./components/arrows";
import { ContainerLoading } from "../LoadingEditor/styles";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";

interface ScrollTemplatesProps {
  image?: string;
  text: string;
}

interface ITemplatesData {
  bits_templates_category?: string;
  created_at?: string;
  creator_id?: string;
  description?: string;
  id?: string;
  key_words?: string;
  last_editor_id?: string;
  template?: any;
  thumbnail?: string;
  thumbnail_url?: string;
  title?: string;
  updated_at?: string;
  usage_counter?: number;
}

interface TemplatesCategoriesProps {
  id: string;
  category: string;
  templates: ITemplatesData[];
}

type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

const ScrollTemplates: React.FC<ScrollTemplatesProps> = ({ image, text }) => {
  const { dragUrl } = useMainHook();
  const [loading, setLoading] = useState<boolean>(true);
  const [templatesByCategories, setTemplateByCategories] = useState<
    TemplatesCategoriesProps[]
  >([]);

  const [selected, setSelected] = useState<string[]>([]);
  // can save and restore position if needed
  const [position, setPosition] = useState(100);

  const isItemSelected = (id: string): boolean =>
    !!selected.find(el => el === id);

  const handleItemClick =
    (itemId: string) =>
    ({ getItemById }: scrollVisibilityApiType) => {
      const itemSelected = isItemSelected(itemId);

      console.log(getItemById(itemId));

      setSelected((currentSelected: string[]) =>
        itemSelected
          ? currentSelected.filter(el => el !== itemId)
          : currentSelected.concat(itemId)
      );
    };
  //if we need disable scroll or enable
  // const { disableScroll, enableScroll } = usePreventBodyScroll();

  const restorePosition = useCallback(
    ({
      scrollContainer
    }: // getItemById,
    // scrollToItem
    scrollVisibilityApiType) => {
      if (scrollContainer.current) {
        scrollContainer.current.scrollLeft = position;
      }
    },
    [position]
  );

  const savePosition = useCallback(
    ({ scrollContainer }: scrollVisibilityApiType) =>
      !!scrollContainer.current &&
      setPosition(scrollContainer.current.scrollLeft),
    []
  );
  useEffect(() => {
    const autoLoad = async () => {
      try {
        const responseCategories = await api.get("bits-template-categories");
        const dataApiCategories = responseCategories.data;
        let templatesPerCategory: TemplatesCategoriesProps[] = [];

        if (dataApiCategories.length > 0) {
          for (const value of dataApiCategories) {
            try {
              const dataOfTemplates = await api.get(
                `bits-templates/list-all-category/${value.id}`
              );

              templatesPerCategory.push({
                category: value.title,
                id: value.id,
                templates: dataOfTemplates.data
              });
            } catch (err) {
              console.log(err, "error when fetch id categories");
            }
          }

          setTemplateByCategories(state => {
            let cloneState = [...state];
            cloneState = templatesPerCategory;
            return cloneState;
          });
        }

        setLoading(false);
      } catch (err) {
        console.log(err, "error when get categories");
        setLoading(false);
      }
    };

    autoLoad();
  }, []);

  return (
    <>
      {loading ? (
        <ContainerLoading>
          {/* <LoadingEditor /> */}
          <ContractAnimation />
        </ContainerLoading>
      ) : (
        <Wrapper>
          <>
            {!loading ? (
              <>
                <Heading
                  onDragStart={event => event.preventDefault()}
                  style={{ margin: "1rem auto 0 auto", color: "#343A40" }}
                >
                  Arraste o template para o editor para inserir no documento
                </Heading>
                {templatesByCategories.map(objectCategory => (
                  <>
                    {objectCategory.templates.length > 0 && (
                      <>
                        <Heading> {objectCategory.category} </Heading>
                        <ScrollMenu
                          LeftArrow={LeftArrow}
                          RightArrow={RightArrow}
                          // onInit={restorePosition}
                          onScroll={savePosition}
                          wrapperClassName="exclude-scroll"
                        >
                          {objectCategory.templates.length > 0 &&
                            objectCategory?.templates?.map(template => (
                              <Card
                                key={template.id}
                                title={template.id}
                                itemId={template.id} // NOTE: itemId is required for track items
                                onClick={handleItemClick(template.id)}
                                selected={isItemSelected(template.id)}
                                src={template.thumbnail_url}
                                dragUrl={dragUrl}
                              />
                            ))}
                        </ScrollMenu>
                      </>
                    )}
                  </>
                ))}
              </>
            ) : (
              <LoadingEditor>
                <ContainerLoading>
                  {/* <LoadingEditor /> */}
                  <ContractAnimation />
                </ContainerLoading>
              </LoadingEditor>
            )}
          </>
        </Wrapper>
      )}
    </>
  );
};

export { ScrollTemplates };
